<template>
  <div>
    <v-skeleton-loader
      v-if="loading"
      type="image-list"
      :types="{
        'image-list': 'avatar@8'
      }"
    />
    <div
      class="d-flex flex-row flex-wrap avatar-list"
      v-if="false === loading"
    >
      <v-avatar
        v-for="(img, i) in images"
        :key="'img-' + i"
        color="primary"
        size="100"
        @click="selectImage(img)"
        return-object
        :class="[selectedImage === img['id'] && 'selected-item']"
      >
        <v-img
          :alt="img.alt"
          :src="img.src"
          class="ma-2 selectable"
          max-height="100"
          max-width="100"
        />
      </v-avatar>
    </div>
  </div>
</template>
<script>

  import fetch from '@/utils/fetch';

  export default {
    name: "SelectImage",
    props: {
      value: Object,
    },
    data: () => ({
      images: [],
      loading: false,
      selectedImage: null,
      gilbSignature: {
        src: 'data:image/png;base64,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',
        alt: 'Unterschrift Frau Gilb'
      },
      grabruckerSignature: {
        src: 'data:image/png;base64,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',
        alt: 'Unterschrift Frau Grabrucker'
      }
    }),
    mounted() {
      // no vuex available here
      this.loading = true;
      const params = { section: 'cms', itemsPerPage: 25, page: 1 };
      fetch('documents', { params })
        .then(response => response.json())
        .then(retrieved => {
          this.images = [...retrieved['hydra:member'].map(item => {
            return {
              src: `${process.env.VUE_APP_API_ENTRYPOINT}${item.contentUrl}`,
              alt: item.name,
              id: item['@id']
            }
          }), ...[this.gilbSignature, this.grabruckerSignature]]
          this.loading = false;
        }).catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    methods: {
      selectImage(img) {
        this.selectedImage = img.id;
        this.$emit('input', img);
      }
    }
  }
</script>
<style lang="scss" scoped>


  .avatar-list {
    gap: 20px;
  }

  .v-avatar {
    &:hover {
      cursor: pointer;
    }

    &.selected-item {
      border: 1px solid #327ca1;
      box-shadow: 0 0 10px 2px rgba(50, 124, 161, 0.4);
    }
  }

  ::v-deep .v-skeleton-loader {
    width: 100%;

    &__image-list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      flex-wrap: wrap;
      justify-items: center;
      margin: 0 auto;
      grid-gap: 20px;
    }
  }
</style>
